import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";

const API_URL = environment.apiUrl + 'customers/';
const API_URL_HUBSPOT = environment.apiUrl + 'hubspot/';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(
    private http: HttpClient
  ) {}

  createCustomer(event: any) {
    return this.http.post(API_URL + '', event, { responseType: 'json' });
  }

  getCustomers() {
    return this.http.get(API_URL + '', { responseType: 'json' });
  }

  updateCustomer(id: string, customer: any) {
    return this.http.put(API_URL + id, customer, { responseType: 'json' });
  }

  getAllProperties(hubspotCustomerId: number, objectTypes: string[]): Observable<any> {
    return this.http.post(environment.apiUrl + '/hubspot/properties?hubspotCustomerId=' + hubspotCustomerId, objectTypes, { responseType: 'json' });
  }

  getAllPropertiesAsFile(hubspotCustomerId: number) {
    return this.http.get(environment.apiUrl + '/hubspot/properties-file?hubspotCustomerId=' + hubspotCustomerId, { responseType: 'blob' });
  }

  getIntegrations(customerId: number): Observable<any> {
    return this.http.get(API_URL_HUBSPOT + 'customer-id?customerId=' + customerId, { responseType: 'json' });
  }
}
